/* ############################################################################
   Config & Declarations
############################################################################ */

/* ############################################################################
   Functions
############################################################################ */


/* Ansprechpartnersuche
############################################ */

var geocoder = false;

var contactSearch = {};
contactSearch.target = document.querySelector('.js-contactsearch');
contactSearch.spinner = "<span class='loading-pulse'></span>";
contactSearch.hasGeodata = false;
contactSearch.data = {};
contactSearch.data.aps = [];
contactSearch.data.defaultAp;
contactSearch.data.position = {};
contactSearch.data.countrycode;
contactSearch.data.latlng;

contactSearch.func = (function () {

  var exports = {};

  function displayMessage(message) {
    contactSearch.target.innerHtml = message;
  };

  function displayContact(contact) {
    var html = "";
    
    if (typeof contact === 'object') {
      var content = contact.content;

      html += "<div class=' image-holder -cover -square -top'><img src='" + content.imageUrl + "' class='scale'></div>";
      html += "<h3 style='margin-top: 1rem'>" + content.title + "</h3>";
      html += "<div itemprop='address' itemscrope>";
      html += "<span itemprop='streetAddress'>";
      html += "<p>" + content.adresse.replace(/(?:\r\n|\r|\n)/g, '<br>') + "</p>"; // replace control character with br
      html += "</span>";
      html += "</div>";

      html += "<span itemprop='telephone'>" + content.mobil + "</span>";
      html += "<span itemprop='telephone'>" + content.telefon + "</span>";
      html += "<span itemprop='faxNumber'>" + content.fax + "</span>";
      html += "<span itemprop='email'><a href='mailto:" + content.email + "'>" + content.email + "</a></span>";
      html += "<span><a target='_blank' href='" + content.website + "'>" + content.website + "</a></span>";
    }
    else {
      html = contactSearch.data.defaultAp;
    }

    contactSearch.target.innerHTML = html;
    mailViaJs.func.init();
  };

  // recieve the users position. First Geolookup then IP lookup fallback
  function getPosition(forceGps) {

    var position;
    
    // Check if the user is in germany.
    if (contactSearch.data.countrycode == "DE") {
      
      // Check if the user forced GPS Location (for example: he clicked the link)
      if (forceGps) {
        displayMessage(contactSearch.spinner + contactSearch.data.translations.determinatingLocation); // translations set in site/snippets/ansprechpartner.php
        var options = { enableHighAccuracy: false, timeout: 5000 };

        // get coordinates and geocode for zip code
        navigator.geolocation.getCurrentPosition(
          function (pos) {
            displayMessage(contactSearch.spinner + contactSearch.data.translations.gettingZip); // translations set in site/snippets/ansprechpartner.php
            position = new google.maps.LatLng(pos.coords.latitude, pos.coords.longitude);

            geocode(position);
          },
          function (error) {
            displayContact();
          },
          options
        );
      }
      else {
        // just display defaultap due to inaccuracy of the ipinfo.io database ^schi 12.2016
        // this.geocode(this.data.iplatlng);
        displayContact();
      }
    }
    // We're not in Germany
    else {
      var ap = this.data.aps.filter(function (el) {
        return (el.content.laenderkuerzel == contactSearch.data.countrycode);
      });

      if (ap.length > 0) {
        displayContact(ap[0]);
      }
      else {
        // no contacts found
        displayContact();
      }
    }
  }

  
  var loadScriptAsync = function(uri){
    return new Promise((resolve, reject) => {
      var tag = document.createElement('script');
      tag.src = uri;
      tag.async = true;
      tag.onload = () => {
        resolve();
      };
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    });
  }
    
  // Geocodes latlng coordinates to a zip code
  function geocode(position) {
    var geoRequest = {};
    geoRequest.id = {};
    geoRequest.timedOut = false;

    // Geocode the coordinates
    // geocoder.geocode({ 'latLng': position }, function(results, status) {
    geocoder.geocode({ 'location': position }, function (results, status) {
      if (geoRequest.timedOut) {
        return;
      }
      else {
        clearTimeout(geoRequest.id);
      }

      if (status == google.maps.GeocoderStatus.OK) {
        var address_components = results[0].address_components;
        var postalCode;
        var countryCode;

        // Get the postal code
        for (var i = 0; i < address_components.length; i++) {
          if (address_components[i].types == "postal_code") {
            postalCode = address_components[i].short_name;
            continue;
          }

          if (address_components[i].types[0] == "country") {
            countryCode = address_components[i].short_name;
            continue;
          }
        }

        // Check countrycode against germany to suppress unwanted results
        if (countryCode != "DE") {
          displayContact();
          return;
        }

        if (postalCode !== undefined) {
          // Filter out the matching zip ranges
          var filtered = contactSearch.data.aps.filter(function (el) {
            var vg = el.content.vertriebsgebiet;

            // Is the postalCode in between any range?
            for (var i = 0; i < vg.length; i++) {
              if ((vg[i].from <= postalCode) && (vg[i].to >= postalCode)) {
                return true;
              }
            }

            return false; // remove if zip didnt match any range
          });

          if (filtered.length) {
            displayContact(filtered[0]);
          }
          else {
            displayContact();
          }
        }
        else {
          displayContact();
        }
      }
      else if (status == google.maps.GeocoderStatus.ZERO_RESULTS) {
        displayContact();
      }
      else {
        displayContact();
      }
    });

    // Make the Request time out after 5 seconds
    geoRequest.id = setTimeout(function () {
      geoRequest.timedOut = true;
      console.log("Geocoder timed out.");
    }, 5000);
  };

  // initiates the contactSearch
  exports.init = function (options) {

    contactSearch.data.translations = options.translations;
      
    contactSearch.forcegpslink = "<a href='#gps' class='js-contactsearch--forcegps btn btn-default btn-service btn-invers'>" + options.translations.find_dealer_via_gps + "</a>";
    contactSearch.data.aps = options.aps;
    contactSearch.data.countrycode = options.countrycode.toUpperCase();

    contactSearch.data.defaultAp = options.defaultAp;
    contactSearch.target.innerHTML = options.defaultAp;
    
    if (!privacy.func.getApplicationCookie()) return;
    
    loadScriptAsync(options.mapsSrc).then(function(){
      
      contactSearch.data.iplatlng = new google.maps.LatLng(options.latlng);
      contactSearch.target.innerHTML = "asasas"; //;contactSearch.spinner + options.translations.searchingContact; // translations set in site/snippets/ansprechpartner.php
  
      geocoder = new google.maps.Geocoder();

      if (!options.latlng) options.latlng = { lat: false, lng: false };
  
      getPosition(false);
  
      if (contactSearch.data.countrycode == "DE") {
        document.querySelector('.js-contactsearch--controls').innerHTML = contactSearch.forcegpslink;
      }
      document.querySelector('.js-contactsearch--forcegps').addEventListener('click', function () {
        this.textContent = options.translations.find_dealer_retry;
        getPosition(true);
      });
    });


  };

  return exports;

})();


/* Diverse Helper
############################################ */

var helper = {};
helper.func = (function () {

  var exports = {};

  exports.get_position = function (ele) {
    let rect = ele.getBoundingClientRect(),
      scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
      scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
  }

  exports.is_visible = function (ele) {
    return window.getComputedStyle(ele).display === "none" ? false : true;
  }

  exports.showform = function (id) {
    document.querySelector("#toggle-" + id).fadeOut();
    document.querySelector("#form-event-" + id).classList.remove("form-hidden");
  }

  return exports;
})();


/* Formbuilder
############################################ */

var formbuilder = {};
formbuilder.func = (function () {
  var exports = {};

  function initContactForm() {
    var form = document.querySelector('[data-contactform]');
    if (!form) return;

    var submitbutton = form.querySelector('[data-submitbutton]');
    var feedback = form.querySelector('[data-form-feedback]');
    var checkAgreement = form.querySelector('[data-check-agreement]');
    var spinner = form.querySelector('[data-ajax-spinner]');

    checkAgreement.addEventListener('change', handleChangeCheckAgreement);
    checkAgreement.removeAttribute('disabled');

    if (!submitbutton || !feedback) return;

    var fields = {};
    var elements = form.querySelectorAll('[name]');

    for (var i = 0; i < elements.length; i++) {
      var field = elements[i];
      fields[field.name] = field;
    }

    function formIsLoading() {
      submitbutton.setAttribute('disabled', true);
      spinner.classList.remove('invisible');
    }

    function formFinishedLoading() {
      submitbutton.removeAttribute('disabled');
    }

    function formHasSuccess(message) {
      feedback.classList.remove('invisible');
      feedback.innerHTML = message;
      feedback.classList.add('bg-success');
      feedback.classList.remove('bg-danger');
      spinner.classList.add('invisible');
      form.reset();
    }

    function formHasError(message) {
      feedback.classList.remove('invisible');
      feedback.innerHTML = message;
      feedback.classList.add('bg-danger');
      feedback.classList.remove('bg-success');
      spinner.classList.add('invisible');
    }

    function handleChangeCheckAgreement(e) {
      if (this.checked) {
        submitbutton.removeAttribute('disabled');
      }
      else {
        submitbutton.setAttribute('disabled', true)
      }
    }

    var onload = function (e) {

      var response = JSON.parse(e.target.response);

      if (e.target.status === 200) {
        formHasSuccess(JSON.parse(e.target.response).message);
      }
      else {
        try {
          var response = JSON.parse(e.target.response);
          formHasError(response.message);
        }

        //Sollte eigentlich niemals passieren
        catch (e) {
          formHasErrpr('An unexpeected error occured. Please try again later.');

        }
      }
    }

    var submit = function (e) {
      formIsLoading();

      e.preventDefault();
      var request = new XMLHttpRequest();

      try {
        request.onreadystatechange = function () {
          if (request.readyState == 4 && request.status == 0) {
            formHasError("An unexpeected error occured. Please make sure that you are connected with the internet when submitting the form.");
            formFinishedLoading();
          }
        };
        var data = new FormData(e.target);

        //Sprache aus URL ziehen
        var language = window.location.pathname.split("/")[1];
        if (language != 'en' && language != 'de')
          language = 'de';

        data.language = language;

        data.append('language', language);

        if (location.href.match(/localhost/)) {
        } else {
          request.open('POST', e.target.action);
          request.onload = onload;
          request.send(data);
        }

      } catch (e) {
        console.log(e);
      }
    }

    form.addEventListener('submit', submit);
  }

  exports.init = function () {
    let form = document.querySelector(".js-form");

    if (form !== null) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        formular.send(this);
      });
    }

    initContactForm();
  }

  return exports;
})();


/* Blueimp
############################################ */

var blueimpGaleries = {};
blueimpGaleries.data = {};
blueimpGaleries.func = (function () {
  var exports = {};

  function initBlueimp(uid) {
    var linkId = "blueimp-gallery-links-" + uid,
      caption_container = document.querySelector("#blueimp-gallery-caption-" + uid),
      caption_container_small = false,
      links = document.getElementById(linkId).querySelectorAll("[data-blueimp-sources]");

    var options = {
      container: '#blueimp-gallery-' + uid,
      startSlideshow: true,
      carousel: true,
      indicator: false
    };

    // Gibt es für ein alternatives Layout noch einen Container?
    if (document.querySelector(`#blueimp-gallery-caption-${uid}-small`) !== null) {
      caption_container_small = document.querySelector("#blueimp-gallery-caption-" + uid + "-small");
    }

    if (caption_container !== null) {
      options.onslideend = function (index, slide) {
        var caption_title = this.list[index].getAttribute('data-caption-title');
        caption_title = (caption_title) ? "<h3>" + caption_title + "</h3>" : "";

        var caption_text = this.list[index].getAttribute('data-caption-text');
        caption_text = (caption_text) ? "<p>" + caption_text + "</p>" : "";

        var linkurl = this.list[index].getAttribute('data-url');

        while (caption_container.firstChild) caption_container.removeChild(caption_container.firstChild);
        if (caption_container_small) {
          while (caption_container_small.firstChild) caption_container_small.removeChild(caption_container_small.firstChild);
         }
        if (caption_title || caption_text) {
          var t = caption_title + caption_text;
          if (linkurl && linkurl.match(/[a-z]/)) {
            t = '<a href="' + linkurl + '">' + caption_title + '</a>';
          }
          caption_container.innerHTML= t;
          if (caption_container_small) { caption_container_small.innerHTML= t; }
        }
      }
    }

    // Bugfix
    document.querySelector("body").style.overflow = "none";

    return blueimp.Gallery(links, options);;
  }

  function initProductGallery() {
    const productGalleryLinks = document.querySelectorAll(".product-slider-nav-wrap a");
    productGalleryLinks.forEach(link => {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        document.querySelectorAll(".product-slider-nav-wrap a").forEach(ele=>ele.classList.remove("active"));
        link.classList.add("active");
        blueimpGaleries.data.galeryObjects["blueimp-gallery-product-slider"].slide(link.dataset.index);
      });
    });

  }

  exports.init = function (pattern) {

    blueimpGaleries.data.galeries = {};
    blueimpGaleries.data.galeryObjects = {};

    let galeries = document.querySelectorAll(pattern);

    galeries.forEach(function (ele) {
      var id = ele.id + "ok";
      blueimpGaleries.data.galeries[id] = {};
      blueimpGaleries.data.galeries[id].offset = helper.func.get_position(ele.parentElement);
    });

    galeries.forEach(function (ele) {
      var id = ele.id;
      var uid = ele.dataset.uid;
      blueimpGaleries.data.galeryObjects[id] = initBlueimp(uid);
    });

    if (document.querySelector(".product-slider-nav-wrap") !== null) {
      initProductGallery();
    }
  }
  return exports;
})();


/* Priority Plus Navigation
############################################ */

var priorityNav = {

  // used multiple times, so saving.
  menu: null,
  overflowNav: null,
  allNavElements: null,

  init: function () {
    priorityNav.menu = document.querySelector(".priority-nav");
    priorityNav.overflowNav = document.querySelector('.overflow-nav');

    this.bindUIActions();
    this.setupMenu();

    document.querySelector('body').addEventListener('click', function (e) {

      //Erst abfragen, ob die Funktion indexOf vorhanden ist, da es sonst zu bei Klick auf SVG-Grafiken Fehler geschmissen werden.
      if (e.target.className.indexOf && e.target.className.indexOf('dropdown') < 0) {
        priorityNav.overflowNav.classList.remove('open');
      }
    });

    priorityNav.menu.classList.remove('-beforeinit');

  },

  setupMenu: function () {

    // priorityNav.menu.style.overflow = "hidden";

    // select all visible elements without the "mehr"-element
    let elements = document.querySelectorAll(".priority-nav > ul > li:not(.overflow-nav)");
    priorityNav.allNavElements = [...elements].filter(function (ele) {
      if (helper.func.is_visible(ele)) return ele;
    });

    // Pointer auf letztes Element zeigen lassen
    var pointer = priorityNav.allNavElements.length-1;

    // Checking top position of first item (sometimes changes)
    var firstElementPos = helper.func.get_position(document.querySelector(".priority-nav > ul > li"));

    // Selektiere das Letzte Element …
    var lastElement = priorityNav.allNavElements[pointer];

    // … und hole dessen Position
    var lastElementPos = helper.func.get_position(lastElement);

    // Wenn Position Top vom ersten Element anders als vom letzten Element …
    if (firstElementPos.top !== lastElementPos.top) {
      // … dann Mehr-Dropdown einblenden
      priorityNav.overflowNav.classList.add("show-inline-block");
    } else {
      return;
    }

    var currentElement = lastElement;
    var wrappedElements = [];
    var highPriorities = [];

    //Solange top-position vom ersten Element anders als vom letzten Elemetn ist und noch nicht alle Elemente durchlaufen wurden
    while ((firstElementPos.top !== lastElementPos.top) && (pointer > 0)) {

      if (!currentElement.classList.contains('high-priority')) {
        currentElement.classList.add('hide-important');
        wrappedElements.push(currentElement);
      } else {
        highPriorities.push(currentElement);
      }

      currentElement = priorityNav.allNavElements[pointer];
      currentElementPos = helper.func.get_position(currentElement);
      lastElementPos = helper.func.get_position(lastElement);

      pointer--;
    }

    // Loop through all the nav items...
    var overflowList = document.querySelector(".overflow-nav-list");
    wrappedElements.forEach(function (item) {
      let clone = item.cloneNode(true);
      clone.classList.remove('hide-important');
      overflowList.append(clone);
    });

    // Hi Priorities wieder einblenden
    highPriorities.forEach(function (item) {
      item.classList.remove('hide-important');
    });
    priorityNav.menu.style.overflow = "visible";

  },

  tearDown: function () {

    var overflowNavList = document.querySelector(".overflow-nav-list");
    while (overflowNavList.firstChild) overflowNavList.removeChild(overflowNavList.firstChild);

    document.querySelector(".overflow-nav").classList.remove("show-inline-block");
    priorityNav.allNavElements.forEach(function (item) { item.classList.remove("hide-important"); });
  },

  bindUIActions: function () {
    var resizeId;

    window.addEventListener('resize', function () {
      priorityNav.menu.classList.add("resizing");
      clearTimeout(resizeId);
      resizeId = setTimeout(
        function () {
          priorityNav.tearDown();
          priorityNav.setupMenu();
          priorityNav.menu.classList.remove("resizing");
        }, 500);
    });
  }
}


/* Dropdown
############################################ */
var menu = {};
menu.data = {}
menu.func = (function () {
  var exports = {};

  function addClickInteraction() {

    document.addEventListener('click', function (event) {

      let targetElement = event.target;
      if (
        targetElement.value ||
        targetElement.type === "submit"
      ) return;

      // event.preventDefault();

      do {
       
        if (targetElement === document) {
          return;
        }

        if (targetElement.hasAttribute("data-scrollto")) {
          location.href = `#${targetElement.dataset.scrollto}`;
          return;
        }

        if (targetElement.href && targetElement.href !== undefined && !targetElement.href.match(/.*#$/)) {
          if (targetElement.target && targetElement.target === '_blank') {
            window.open.href = targetElement.href;
            return;
          }
          location.href = targetElement.href;
          return;
        }

        if (targetElement.classList === undefined) {
          closeActiveDropdown();
          return;
        };
        if (targetElement.classList.contains("dropdown")) {
          handleDropdown(targetElement);
          return;
        }

        if (targetElement.dataset.index) {
          return;
        }
        targetElement = targetElement.parentNode;

      } while (targetElement);
      closeActiveDropdown();
    });
  }

  function handleDropdown(ele) {
    if (ele.parentElement.id !== 'overflow-nav-list' && ele != menu.data.activeDropdown) {
      closeActiveDropdown();
    }
    if (ele.classList.contains("open")) {
      ele.classList.remove("open");
      menu.data.activeDropdown = false;
    } else {
      ele.classList.add("open");
      menu.data.activeDropdown = ele;
    }

  }

  function closeActiveDropdown() {
    if (menu.data.activeDropdown) {
      menu.data.activeDropdown.classList.remove("open");
      menu.data.activeDropdown = false;
    }
  }

  exports.init = function () {
    menu.data.activeDropdown = false;
    addClickInteraction();
  }
  return exports;
})();


/* Privacy
############################################ */

var privacy = {};
privacy.data = {}
privacy.func = (function () {
  var exports = {};

  exports.checkApplicationCookie = function (selectorId, alternativeId) {
    var selector = document.getElementById(selectorId);
    var alternative = document.getElementById(alternativeId);

    if (selector === null && getApplicationCookie() === false && alternative !== null) {
      alternative.querySelector('.btn').setAttribute('data-js-cookie-dialog', '');
      initPrivacyDialog();
      alternative.classList.remove('hidden');
    }
  }

  let privacySettingsSaverIsInitialized = false;
  function initPrivacySettingsSaver() {
    // ensure init process is only called once
    if (privacySettingsSaverIsInitialized) {
      return;
    }
    privacySettingsSaverIsInitialized = true;

    var privacyDisclaimer = document.getElementById('privacy-disclaimer-dialog');
    var privacySettings = document.getElementById('privacy-settings-dialog');

    document.querySelectorAll('[data-privacy]').forEach((ele) => {
      ele.addEventListener('click', function (e) {
        e.preventDefault();

        let shouldReload = false;

        // Process checkboxes in privacy settings
        if (ele.dataset.privacy === "#privacy-settings-dialog") {
          // reload, if application cookie setting has changed
          shouldReload = document.getElementById('application-cookies').checked !== getApplicationCookie();

          // store each privacy setting in a cookie
          privacySettings.querySelectorAll("[value*=privacy]").forEach(item => {
            if (item.checked === true) {
              exports.cookieManager.store(item.value, 1, 365, '/');
            } else {
              exports.cookieManager.store(item.value, 0, 365, '/');
            }
          });
          privacySettings.classList.add("is-closed");
        }

        // or process acceptance button in privacy disclaimer
        else {
          shouldReload = getApplicationCookie() === false;
          ele.dataset.privacy.split(',').forEach(value => exports.cookieManager.store(value, 1, 365, '/'));
          privacyDisclaimer.classList.add("is-closed");
        }


        if (shouldReload) {
          location.reload();
        }
        return;
      });
    });
  }

  function privacyDisclaimerDialog() {
    let privacyDisclaimer = document.querySelector('#privacy-disclaimer-dialog');
    let privacySettings = document.querySelector('#privacy-settings-dialog');

    if (privacyDisclaimer) {
      initPrivacySettingsSaver();

      let settingsOpener = privacyDisclaimer.querySelector("[data-opener]");
      settingsOpener.addEventListener('click', () => {
        privacyDisclaimer.classList.add("is-closed");
        privacySettings.classList.remove("is-closed");
      });
    }
  }

  function privacySettingsDialog() {
    let privacySettings = document.querySelector('#privacy-settings-dialog');

    if (privacySettings) {
      privacySettings.classList.remove("is-closed");
      initPrivacySettingsSaver();
    }
  }

  function initPrivacyDialog() {
    let privacyDisclaimer = document.querySelector('#privacy-disclaimer-dialog');
    document.querySelectorAll('[data-js-cookie-dialog]').forEach(item => {
      item.addEventListener('click', event => {
        if (privacyDisclaimer) {
          privacyDisclaimer.classList.add("is-closed");
        }
        privacySettingsDialog();
      });
    });
  }

  exports.init = function () {
    privacyDisclaimerDialog();
    initPrivacyDialog();
  }

  let getApplicationCookie = function () {
    return exports.cookieManager.read('privacy_disclaimer_application') === '1' ? true : false;
  }

  exports.getApplicationCookie = getApplicationCookie;

  exports.cookieManager = {
    store: function (cookieName, cookieValue, cookieDurationDays, cookiePath) {
      var cookieExpireTime = new Date();
      cookieExpireTime.setTime(cookieExpireTime.getTime() + (cookieDurationDays * 24 * 60 * 60 * 1000));
      var cookie = cookieName + '=' + cookieValue + ';';
      var expires = 'expires=' + cookieExpireTime.toUTCString() + ';';
      var path = 'path=' + cookiePath + ';';
      document.cookie = cookie + expires + path;
    },

    read: function (cookieName) {
      var name = cookieName + '=';
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          var cookieVal = c.substring(name.length, c.length);
          if (cookieVal !== false) return cookieVal;
        }
      }
      return '';
    }
  }

  return exports;
})();


/* Header Minifizierung
############################################ */

var minifyHeader = {};
minifyHeader.data = {}
minifyHeader.func = (function () {
  var exports = {};

  function handleIntersection(entries, observer) {
    entries.forEach(entry => {
      entry.target.classList = entry.isIntersecting ? "" : "minified";
    });
  }

  exports.init = function () {
    const options = {
      rootMargin: "-40px"
    };

    let minifyObserver = new IntersectionObserver(handleIntersection, options);
    let target = document.querySelector('#navigation');
    minifyObserver.observe(target);
  }

  return exports;
})();


/* Offcanvas
############################################ */

var offCanvas = {};
offCanvas.data = {}
offCanvas.func = (function () {
  var exports = {};

  function handleOffcanvas() {

    document.querySelector(".row-offcanvas").classList.toggle('active');
  }

  exports.init = function () {

    offCanvas.data.active = false;
    document.querySelector('[data-toggle="offcanvas"]').addEventListener('click', function () {
      handleOffcanvas();
    });
  }

  return exports;
})();


/* Suchfunktion
############################################ */
var search = {};
search.data = {}
search.func = (function () {
  var exports = {};

  function handleSearchGui() {
    document.querySelector("[data-toggle=search]").addEventListener('click', function (ele) {
      document.querySelector('#search').classList.toggle("active");
      document.querySelectorAll('.menuitem').forEach(ele=>ele.classList.toggle("hide"));
    });
  }

  function handleSearch() {
    document.querySelector('#searchform').addEventListener('submit', function (event) {
      event.preventDefault();
      var suchwort = document.querySelector('#suchwort').value;
      if (suchwort != "") {
        var language = window.location.pathname.split("/")[1];
        if (language != 'en' && language != 'de')
          language = 'de';
        location.href = '/' + language + "/suche/?q=" + suchwort;

      }
    });
  }

  exports.init = function () {
    handleSearchGui();
    handleSearch();
  }
  return exports;
})();


/*  Mail via js
############################################ */
var mailViaJs = {};
mailViaJs.func = (
  function () {
    var exports = {};

    const convertMailtoLinks = () => {
      document.querySelectorAll('[href *= mailto]').forEach(item => {
        const target = item.href.replace(/mailto\:/, "");
        item.removeAttribute('href');
        item.dataset.jsContact = btoa(target);
        item.classList.add('hand');
      });

    }

    const initMailtoLinks = () => {
      document.querySelectorAll('[data-js-contact]').forEach(item => {
        item.addEventListener('click', event => {
          event.preventDefault;
          const ele = event.target;
          const target = ele.dataset.jsContact;
          const subject = `Anfrage zu ${document.title}`;
          window.location.href = `mailto:${atob(target)}?subject=${subject}`;
        });
      });
    }

    exports.init = function () {
      convertMailtoLinks();
      initMailtoLinks();
    }
    return exports;
  }
)();



/* Privacy Video Embed
############################################ */

var privacyVideos = {};
privacyVideos.func = (function () {
  var exports = {};

  const initVideos = () => {
    
    document.querySelectorAll('[data-js-video-content]').forEach(item => {
      if (privacy.func.getApplicationCookie()) {
        const code = atob(item.innerHTML);
        item.parentNode.innerHTML = code;
      }
    });
  }

  exports.init = function () {
    initVideos();
  }

  return exports;
})();

/* ############################################################################
   Main
############################################################################ */

document.addEventListener("DOMContentLoaded", function () {

  // Blueimp initialisieren
  blueimpGaleries.func.init(".blueimp-gallery");

  // Cookie Banner und so
  privacy.func.init();

  // Menu initialisieren
  menu.func.init();

  // Priority Plus initialisieren
  priorityNav.init();

  // Header Minifizierung initialisieren
  minifyHeader.func.init();

  // Offcanvas initialisieren
  offCanvas.func.init();

  // Suche initialisieren
  search.func.init();

  // Formbuilder initialisieren
  formbuilder.func.init();

  // Mailto via JS
  mailViaJs.func.init();

  // YT Videos zeigen
  privacyVideos.func.init();

  // Display button to change cookie settings, if map is not visible
  privacy.func.checkApplicationCookie('map-code', 'map-disabled');

});
